import React from 'react';
import type {SetRequired} from 'type-fest';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {
	RadiosField,
	type RadiosFieldProps,
} from '@netx/core-components/RadiosField';
import {splitEventHandler} from '@netx/core-next/utils';
import {useFormInput} from '../hooks';
import type {WithLegacyCommonFormFieldProps} from '../types';

export interface LegacyFormRadiosFieldProps
	extends WithLegacyCommonFormFieldProps<
		SetRequired<RadiosFieldProps, 'name'>
	> {}

export const LegacyFormRadiosFieldPrimitive = (
	{
		error,
		form,
		formFieldOptions,
		onChange,
		...props
	}: LegacyFormRadiosFieldProps,
	ref: any,
) => {
	const _error = typeof error === 'string' ? error : error?.message;

	useFormInput(props.name, props.value, form, {
		required: props.required,
		...formFieldOptions,
	});

	const handleChange = useConstCallback(
		splitEventHandler(onChange, (event, value) => {
			form?.setValue(props.name, value);
		}),
	);

	return (
		<RadiosField ref={ref} error={_error} {...props} onChange={handleChange} />
	);
};

/** @deprecated */
export const LegacyFormRadiosField = React.forwardRef(
	LegacyFormRadiosFieldPrimitive,
);

export default LegacyFormRadiosField;
